import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css'
import NumericInput from 'react-numeric-input';
import Classnames from 'classnames';
import Typeahead from './Typeahead/Typeahead.js';
import Uploader from './Uploader/Uploader.js';
import './HoldingsEditor.css';

class HoldingsEditor extends PureComponent {

	static defaultProps = {
		initialHoldings: null,
		params: null,
		typeaheadUrl: 'https://dpddev.wisdomtree.com/api/securityfund/typeahead/',
		checkTickersUrl: 'https://dpddev.wisdomtree.com/api/securityfund/ticker_names/',
		updateHoldings: null, // Method called when holdings are updated 
		totalValue: 1000000,
	};

	constructor(props) {
		super(props);

		this.handleEntitySelection = this.handleEntitySelection.bind(this);
		this.handleDeleteHolding = this.handleDeleteHolding.bind(this);
		this.handleDeleteAllHoldings = this.handleDeleteAllHoldings.bind(this);
		this.handleUpdateSlider = this.handleUpdateSlider.bind(this);
		this.handleChangeWeightingType = this.handleChangeWeightingType.bind(this);
		this.handleUploadHoldings = this.handleUploadHoldings.bind(this);

		// Set up the original holdings array based on the strategy (if available)
		let holdings;
		if (props.initialHoldings) {

			// Map out the original holdings into an array
			holdings = props.initialHoldings.tickers.map((ticker, index) => {

				return ({
					ticker: ticker,
					weight: props.initialHoldings.weights[index],
					// name: props.initialHoldings.names[index],
					// externalID: props.initialHoldings.externalIDs[index],
					// amount: props.initialHoldings.weights[index] * props.totalValue,
				})

			})

		} else {
			holdings = null;
		}

		// Set up local state
		this.state = {
			holdings: holdings,
			editingWeight: false,
			sumWeights: null,
			totalValue: null,
			weightType: 'percent',
			failuredFunds: null,
		}

	}

	componentDidMount() {
		this.sumWeights(this.state.holdings);
	}

	// Handle the typeahead's suggestions being chosen. This is passed to the
	// updateSelectedEntities() prop on Typeahead
	handleEntitySelection(entity) {

		let currentHoldings = this.state.holdings;

		let newHolding = {
			ticker: entity.ticker,
			weight: 0,
			amount: 0,
			name: entity.name,
			externalID: entity.externalID,
		}

		// Add on the new entity if there are existing holdings, otherwise
		// create a new array with the new holding
		let newHoldings = currentHoldings ? currentHoldings.concat(newHolding) : [newHolding];

		newHoldings = this.rebalanceWeights(newHoldings);

		// Update local state
		this.setState({
			holdings: newHoldings,
		});

		if (this.props.updateHoldings) {
			this.props.updateHoldings(newHoldings);
		}

		this.sumWeights(newHoldings);
	}

	// Remove the given entity from the list
	handleDeleteHolding(entity) {

		const newHoldings = this.state.holdings.filter(holding => holding.ticker !== entity.ticker);

		// Update local state
		this.setState({
			holdings: newHoldings.length > 0 ? newHoldings : null,
		});

		if (this.props.updateHoldings) {
			this.props.updateHoldings(newHoldings);
		}

		this.sumWeights(newHoldings);

	}

	// Remove all the holdings from the list
	handleDeleteAllHoldings() {

		// Update local state
		this.setState({
			holdings: null
		});

		if (this.props.updateHoldings) {
			this.props.updateHoldings(null);
		}

	}

	// Handle the upload of all holdings
	handleUploadHoldings(holdings, failures) {

		// Rebalance the weights / amounts
		const newHoldings = this.rebalanceWeightsAndAmounts(holdings);

		// Update local state
		this.setState({
			holdings: newHoldings,
			failuredFunds: failures,
		});

		if (this.props.updateHoldings) {
			this.props.updateHoldings(newHoldings);
		}

	}

	// Change the Weighting type - % or $
	handleChangeWeightingType(weightType) {

		// Update local state
		this.setState({
			weightType: weightType
		});

	}

	// Update the weight of a holding from slider or input box
	handleUpdateSlider(value, holding) {

		const {
			weightType,
			totalValue,
		} = this.state;

		value = weightType === 'percent' && value > 1 ? 1 : value;

		let newHoldings = this.state.holdings.map(originalHolding => {
			// Update weight value
			if (originalHolding.ticker === holding.ticker) {

				if (weightType === 'currency') {
					originalHolding.weight = value / totalValue;
					originalHolding.amount = value;
				} else {
					originalHolding.weight = value;
					originalHolding.amount = value * totalValue;
				}

			}
			return originalHolding;
		});

		// Reset weight if only 1 holding
		if (newHoldings.length === 1) {
			newHoldings[0].weight = 1;

			if (weightType === 'percent') {
				newHoldings[0].amount = totalValue;
			}
		}

		// Rebalance the weights / amounts
		newHoldings = this.rebalanceWeightsAndAmounts(newHoldings);
		// Update local state
		this.setState({
			holdings: newHoldings
		});

		if (this.props.updateHoldings) {
			this.props.updateHoldings(newHoldings);
		}

	}

	// Sum up all the weights on a change of input and store in state
	sumWeights(holdings) {

		if (holdings) {

			// Total up the weights
			let sumWeights = this.sumArrayField(holdings, 'weight')

			// Total up the amounts
			let totalValue = this.sumArrayField(holdings, 'amount')

			// Update local state
			this.setState({
				sumWeights: sumWeights,
				totalValue: totalValue,
			});
		}
	}

	// Return sum of a field as part of array
	sumArrayField(array, fieldName) {

		try {
			let fieldArray = array.map(elem => {
				return elem[fieldName];
			})

			// Total up the amounts
			return fieldArray.reduce(function sumofArray(sum, num) {
				return sum + num;
			});

		}
		catch (err) {
			return 0;
		}

	}

	// Rebalance the weights based on the amounts provided. This should
	// only be called when an amount is entered which will automatically
	// force all the weights back to sum to 100
	rebalanceWeightsAndAmounts(holdings) {

		const {
			weightType,
		} = this.state;

		// Total up the amounts
		let totalValue = this.sumArrayField(holdings, 'amount')

		// Total up the weights
		let sumWeights = this.sumArrayField(holdings, 'weight')

		// Update local state
		this.setState({
			sumWeights: sumWeights,
			totalValue: totalValue,
		});

		// Only rebalance if there is more than one holding
		if (holdings.length > 1) {

			// Rebalance the weights
			if (weightType === 'currency') {

				holdings.forEach(holding => {
					holding.weight = holding.amount / totalValue;
				})

				// Rebalance the amounts
			} else {
				holdings.forEach(holding => {
					holding.amount = (holding.weight / sumWeights) * totalValue;
				})
			}
		}

		return holdings;

	}

	// Rebalance the holdings array weights. Assumes that the last holding
	// to be added has a zero weight. Should shrink all the other weights
	// by a proportional amount
	rebalanceWeights(holdings) {


		const {
			totalValue,
		} = this.state;

		// Count of holdings
		let count = holdings.length;

		// If there is only holding then just set weight to 1, and amount to 1M
		if (count === 1) {
			holdings[0].weight = 1;
			holdings[0].amount = 1000000;
			return holdings
		}

		// Get all the weights
		let weights = holdings.map(holding => {
			return holding.weight;
		})

		// Take all but last element
		let originalWeights = [...weights].slice(0, -1);

		// Check if originally proportional
		let isProportional = originalWeights.every((val, i, arr) => val === arr[0]) ? true : false;

		if (isProportional) {

			// Assign the same weight to the new holding
			weights[weights.length - 1] = weights[0];

		} else {

			// Get proportional percentage of each weight (this would be rebased to
			// if initially proportional)
			let proportionalPercentage = 1.0 / count;

			// Assign the proportional to the new holding
			weights[weights.length - 1] = proportionalPercentage;
		}

		// Total up the weights
		let sumWeights = weights.reduce(function sumofArray(sum, num) {
			return sum + num;
		});

		// Calculate the new weights
		let newWeights = weights.map(weight => {
			return weight / sumWeights
		})

		// Update the holdings with new weights and use the total amount and new weights
		// to update amounts
		holdings.forEach((holding, index) => {

			holding.weight = newWeights[index];
			holding.amount = totalValue * newWeights[index];
			return holding;
		})

		return holdings;

	}

	// Format the number per local number format
	formatCurrencyInput(num) {
		return parseFloat(num).toLocaleString();
	}

	// Parse back the formatted string to a number
	parseCurrencyString(stringValue) {
		return stringValue.replace(/,/g, "");
	}

	render() {

		const {
			params,
			typeaheadUrl,
			checkTickersUrl,
		} = this.props;

		const {
			holdings,
			sumWeights,
			totalValue,
			weightType
		} = this.state;

		return (

			<div className="holdings-editor">
				<div className="row">
					<div className="col-md-6">
						<div className="formWrapper">
							<div className="formLabel">Add Individual Tickers</div>
							<Typeahead
								placeholder='Search by Ticker or Name'
								params={params}
								typeaheadUrl={typeaheadUrl}
								currentSelection={this.state.holdings}
								updateSelection={this.handleEntitySelection}
								tabIndex={1}
							/>
						</div>
					</div>
					<div className="col-md-1">
						<div className="formOR">OR</div>
					</div>
					<div className="col-md-5">
						<div className="formWrapper">
							<div className="formLabel">Upload Excel file of {params.client.firstName}'s Current Portfolio</div>
							<Uploader
								checkTickersUrl={checkTickersUrl}
								placeholderLabel='Drop Excel File Here'
								updateHoldings={this.handleUploadHoldings}
								token={params.token}
								downloadTemplateLabel='Download Template'
								downloadTemplateTooltipLabel='download-template-tooltip'
								uploadFailureLabel='upload-failures'
							/>
						</div>
					</div>
				</div>
				{(holdings && holdings.length) ?
					<div className="row" style={{ marginTop: '30px' }}>
						<div className="col-md-12">
							<div className="formLabel">Edit Portfolio entered as needed</div>
							<table className='holdings-table'>
								{/* Header of table */}
								<thead className='headings'>
									<tr>
										<th className='order' />
										<th className='ticker'>Tickers</th>
										<th className='name' >Name</th>
										<th className='weight'>Weight %</th>
											{/* <div className='weighting-header'>
												<div className='weighting-header-title'>weighting</div>
												<div className='weight-type'>
													<div
														className={Classnames('option', { selected: weightType === 'percent' })}
														onClick={this.handleChangeWeightingType.bind(this, 'percent')}>
														%
                          </div>
													<div
														className={Classnames('option', { selected: weightType === 'currency' })}
														onClick={this.handleChangeWeightingType.bind(this, 'currency')}>
														$
                                                </div>
												</div>
											</div> */}
										{/* </th> */}
										<th className='delete-col'>
											<div className='delete-all' onClick={this.handleDeleteAllHoldings}>✕</div>
										</th>
									</tr>
								</thead>
								<tbody>

									{holdings.map((holding, rowIndex) => {

										return (
											<tr key={holding.ticker}>
												<td className='order'>{rowIndex + 1}</td>
												<td className='ticker'>
													{holding.ticker}
												</td>
												<td className='name'>
													{holding.name}
												</td>
												<td className='weight'>
													<NumericInput
														step={weightType === 'currency' ? 1 : 0.1}
														min={0}
														max={weightType === 'currency' ? null : 100}
														precision={weightType === 'currency' ? 0 : 1}
														value={weightType === 'currency' ? holding.amount : holding.weight * 100}
														onChange={value => { this.handleUpdateSlider(weightType === 'currency' ? value : value / 100, holding) }}
														style={false}
														snap
														tabIndex={rowIndex + 2}
														format={weightType === 'currency' ? this.formatCurrencyInput : null}
														parse={this.parseCurrencyString}
														className='form-control'
													/>
													{/* <div className='slider-horizontal'>
                                                    <Slider
                                                        min={0}
                                                        max={weightType === 'currency' ? Math.max(totalValue, 1000000) : 1}
                                                        step={weightType === 'currency' ? 1 : 0.001}
                                                        value={weightType === 'currency' ? holding.amount : holding.weight}
                                                        orientation='horizontal'
                                                        handleLabel=''
                                                        tooltip={false}
                                                        onChange={value => { this.handleUpdateSlider(value, holding) }}
                                                    />
                                                </div> */}
												</td>
												<td className='delete-col'>
													<div className='delete' onClick={this.handleDeleteHolding.bind(this, holding)}>✕</div>
												</td>
											</tr>
										)

									})}

									{/* Add Total row */}
									<tr key='total' className='total'>
										<td className='order' />
										<td className='ticker' />
										<td className='name' />
										<td className='sum-weight weight'>
											<NumericInput
												step={weightType === 'currency' ? 1 : 0.1}
												min={0}
												max={weightType === 'currency' ? null : 100}
												precision={weightType === 'currency' ? 0 : 1}
												value={weightType === 'currency' ? totalValue : sumWeights * 100}
												style={false}
												readOnly={true}
												format={weightType === 'currency' ? this.formatCurrencyInput : null}
												className='form-control'
											/>
										</td>
										<td className='delete-col' />
									</tr>
								</tbody>

							</table>
						</div>
					</div>
					: null}
			</div>
		)
	}

}

export default connect(null, {})(HoldingsEditor);



// WEBPACK FOOTER //
// ./src/components/AdvisorMode/HoldingsEditor/HoldingsEditor.js